import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCurrentSnagDetailWithFloorMeta } from '../../../../store/actions/projectActions'

class ViewAllFloorsModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    /// README: Choose part to open
    chooseFloor = (snagDetail, floorid, floorMap) => {
        const flooridMap = { floorid: floorid };
        const floorMeta = { ...floorMap, ...flooridMap };
        this.props.setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta);
    }

    /// README: Compare to sort
    compare(a, b) {
        if (a.dateCreated.seconds < b.dateCreated.seconds) {
            return -1;
        }
        if (a.dateCreated.seconds > b.dateCreated.seconds) {
            return 1;
        }
        return 0;
    }

    render() {
        return (
            <React.Fragment>
                <button className="btn btn-link btn-sm border-left" style={{ textAlign: "end", fontSize: "12px", fontWeight: "bold" }}>View all</button>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        snagDetail: state.firestore.data.Snag,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        project: state.project,
        userData: state.firebase.profile,
        alu: state.alu,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentSnagDetailWithFloorMeta: (snagDetail, floorMeta) => dispatch(setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewAllFloorsModal)
